import { useEffect, useRef } from 'react';
import { Metrics } from '../utils/metrics';
function isNavigationEntry(entry) {
  return entry.entryType === 'navigation';
}
function isResourceEntry(entry) {
  return entry.entryType === 'resource';
}
export const usePublicPageLoadTiming = (route, chunkName) => {
  const hasRunRef = useRef(false);
  useEffect(() => {
    if (hasRunRef.current) {
      return;
    }
    hasRunRef.current = true;
    requestAnimationFrame(() => {
      const navEntries = performance.getEntriesByType('navigation');
      const navEntry = navEntries[0];
      if (!navEntry || !isNavigationEntry(navEntry)) {
        return;
      }
      const tags = {
        route
      };
      const mountTime = performance.now();
      Metrics === null || Metrics === void 0 || Metrics.timer('page-load-ttfb', tags).update(navEntry.responseStart);
      Metrics === null || Metrics === void 0 || Metrics.timer('page-load-dom-content', tags).update(navEntry.domContentLoadedEventEnd);
      Metrics === null || Metrics === void 0 || Metrics.timer('page-load-to-mount', tags).update(mountTime);
      const resourceEntries = performance.getEntriesByType('resource');
      for (const entry of resourceEntries) {
        if (!isResourceEntry(entry)) {
          continue;
        }
        if (entry.name.includes(chunkName)) {
          Metrics === null || Metrics === void 0 || Metrics.timer('page-load-chunk-fetch', tags).update(entry.duration);
          Metrics === null || Metrics === void 0 || Metrics.timer('page-load-chunk-end', tags).update(entry.responseEnd);
          break;
        }
      }
    });
  }, [route, chunkName]);
};